// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Terms_entry-container__i9JT8{
    width: 100vw;
    min-height: 422vw;
    position: relative;
    margin-top: -13vw;
}

.Terms_entry-img__8zgre{
    height: 100vh;
    width: 100vw;
    position: fixed;
    z-index: -1;
}

.Terms_entry-title__GLJTH{
    font-size: 3.7vw;
    font-family: dm-sans-medium;
    width: 100vw;
    text-align: center;
    color: #e65439;
    position: absolute;
    margin-top: 13vw;
    margin-bottom: 6vw;
}

.Terms_terms-container__arD0Y{
    position: absolute;
    width: 100vw;
    height: 40vw;
    margin-top: 20vw;
    padding-left: 7.5vw;
    padding-right: 7.5vw;
    box-sizing: border-box;
}

.Terms_terms-intro__i1I9\\+{
    font-size: 1.1vw;
    font-weight: 300;
    font-family: dm-sans-light;
}

.Terms_terms-info__m8l7q{
    font-size: 1.1vw;
    font-weight: 300;
    font-family: dm-sans-light;
    margin-left: 1.5vw;
    margin-top: 2vw;
}

@media(max-width: 768px){
    .Terms_entry-container__i9JT8{
        width: 100vw;
        min-height: 3355vw;
        position: relative;
        margin-top: -22vh;
    }
    
    .Terms_entry-img__8zgre{
        height: 100vh;
        width: 100vw;
        position: fixed;
        z-index: -1;
    }
    
    .Terms_entry-title__GLJTH{
        font-size: 6vw;
        font-family: dm-sans-medium;
        width: 100vw;
        text-align: center;
        color: #e65439;
        position: absolute;
        margin-top: 160px;
        margin-bottom: 0vh;
    }
    
    .Terms_terms-container__arD0Y{
        position: absolute;
        width: 100vw;
        height: 40vw;
        margin-top: 190px;
        padding-left: 7.5vw;
        padding-right: 7.5vw;
        box-sizing: border-box;
    }
    
    .Terms_terms-intro__i1I9\\+{
        font-size: 4vw;
        font-weight: 300;
        font-family: dm-sans-light;
        margin-top: 7vw;
        text-align: justify;
    }
    
    .Terms_terms-info__m8l7q{
        font-size: 4vw;
        font-weight: 300;
        font-family: dm-sans-light;
        margin-left: 0vw;
        margin-top: 7vw;
        text-align: justify;
    }
}`, "",{"version":3,"sources":["webpack://./src/Pages/FooterPages/TermsAndConditions/Terms.module.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,eAAe;IACf,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,2BAA2B;IAC3B,YAAY;IACZ,kBAAkB;IAClB,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;IACnB,oBAAoB;IACpB,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,0BAA0B;IAC1B,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI;QACI,YAAY;QACZ,kBAAkB;QAClB,kBAAkB;QAClB,iBAAiB;IACrB;;IAEA;QACI,aAAa;QACb,YAAY;QACZ,eAAe;QACf,WAAW;IACf;;IAEA;QACI,cAAc;QACd,2BAA2B;QAC3B,YAAY;QACZ,kBAAkB;QAClB,cAAc;QACd,kBAAkB;QAClB,iBAAiB;QACjB,kBAAkB;IACtB;;IAEA;QACI,kBAAkB;QAClB,YAAY;QACZ,YAAY;QACZ,iBAAiB;QACjB,mBAAmB;QACnB,oBAAoB;QACpB,sBAAsB;IAC1B;;IAEA;QACI,cAAc;QACd,gBAAgB;QAChB,0BAA0B;QAC1B,eAAe;QACf,mBAAmB;IACvB;;IAEA;QACI,cAAc;QACd,gBAAgB;QAChB,0BAA0B;QAC1B,gBAAgB;QAChB,eAAe;QACf,mBAAmB;IACvB;AACJ","sourcesContent":[".entry-container{\n    width: 100vw;\n    min-height: 422vw;\n    position: relative;\n    margin-top: -13vw;\n}\n\n.entry-img{\n    height: 100vh;\n    width: 100vw;\n    position: fixed;\n    z-index: -1;\n}\n\n.entry-title{\n    font-size: 3.7vw;\n    font-family: dm-sans-medium;\n    width: 100vw;\n    text-align: center;\n    color: #e65439;\n    position: absolute;\n    margin-top: 13vw;\n    margin-bottom: 6vw;\n}\n\n.terms-container{\n    position: absolute;\n    width: 100vw;\n    height: 40vw;\n    margin-top: 20vw;\n    padding-left: 7.5vw;\n    padding-right: 7.5vw;\n    box-sizing: border-box;\n}\n\n.terms-intro{\n    font-size: 1.1vw;\n    font-weight: 300;\n    font-family: dm-sans-light;\n}\n\n.terms-info{\n    font-size: 1.1vw;\n    font-weight: 300;\n    font-family: dm-sans-light;\n    margin-left: 1.5vw;\n    margin-top: 2vw;\n}\n\n@media(max-width: 768px){\n    .entry-container{\n        width: 100vw;\n        min-height: 3355vw;\n        position: relative;\n        margin-top: -22vh;\n    }\n    \n    .entry-img{\n        height: 100vh;\n        width: 100vw;\n        position: fixed;\n        z-index: -1;\n    }\n    \n    .entry-title{\n        font-size: 6vw;\n        font-family: dm-sans-medium;\n        width: 100vw;\n        text-align: center;\n        color: #e65439;\n        position: absolute;\n        margin-top: 160px;\n        margin-bottom: 0vh;\n    }\n    \n    .terms-container{\n        position: absolute;\n        width: 100vw;\n        height: 40vw;\n        margin-top: 190px;\n        padding-left: 7.5vw;\n        padding-right: 7.5vw;\n        box-sizing: border-box;\n    }\n    \n    .terms-intro{\n        font-size: 4vw;\n        font-weight: 300;\n        font-family: dm-sans-light;\n        margin-top: 7vw;\n        text-align: justify;\n    }\n    \n    .terms-info{\n        font-size: 4vw;\n        font-weight: 300;\n        font-family: dm-sans-light;\n        margin-left: 0vw;\n        margin-top: 7vw;\n        text-align: justify;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"entry-container": `Terms_entry-container__i9JT8`,
	"entry-img": `Terms_entry-img__8zgre`,
	"entry-title": `Terms_entry-title__GLJTH`,
	"terms-container": `Terms_terms-container__arD0Y`,
	"terms-intro": `Terms_terms-intro__i1I9+`,
	"terms-info": `Terms_terms-info__m8l7q`
};
export default ___CSS_LOADER_EXPORT___;
